import React, { forwardRef, type InputHTMLAttributes } from "react";

import { ScrollWithFade } from "../ScrollWithFade/ScrollWithFade";

interface IBaseInputProps extends InputHTMLAttributes<HTMLInputElement> {}

export const InputWithFade = forwardRef<HTMLInputElement, IBaseInputProps>(
    ({ ...props }, ref) => {
        return <ScrollWithFade as="input" {...props} ref={ref} />;
    },
);

InputWithFade.displayName = "BaseInput";
